import cosurl from './v-cosurl.js'
import drag from './drag.js'

const directive = {
  install: Vue => {
    // 注册全局自定义指令
    Vue.directive('cosurl', cosurl)
    // 注册全局自定义指令
    Vue.directive('drag', drag)
  }
}

// 导出组件
export default directive



// WEBPACK FOOTER //
// ./src/directive/index.js